import ReactOnRails from 'react-on-rails';

import Clipper from '@components/Clipper';
import Article from '@components/pages/Article';

ReactOnRails.register({
  Article,
  Clipper,
});
